import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import BankService from '../services/BankService';

const initialState = {
  data: [],
  datas: [],
  formError: [],
  bankoptions: [],
  pagination: {
    page: 0,
    per_page: 10,
    total: 10,
    totalPages: 10,
  },
  error: null,
  status: '',
  loading: false,
  submitLoading: false,
  isOpenBankDialog: false
};

export const bankList = createAsyncThunk(
  'bank/list',
  async ({ perPage, page, keyword }) => {
    try {
      const resp = await BankService.List({ perPage, page, keyword });
      return resp;
    } catch (e) {
      return e.response;
    }
  },
);

export const bankAdd = createAsyncThunk('bank/add', async (data) => {
  try {
    const resp = await BankService.Create(data);
    return resp;
  } catch (e) {
    return e.response;
  }
});

export const bankEdit = createAsyncThunk('bank/edit', async ({ id, data }) => {
  try {
    const resp = await BankService.Put(id, data);
    return resp;
  } catch (e) {
    return e.response;
  }
});

export const bankDelt = createAsyncThunk('bank/delt', async (id) => {
  try {
    const resp = await BankService.Delt(id);
    return resp;
  } catch (e) {
    return e.response;
  }
});

export const bankAll = createAsyncThunk('bank/all', async () => {
    try {
        const resp = await BankService.All();
        return resp;
    } catch (error) {
        return error.response
    }
})

const bankAction = createSlice({
  name: 'bank',
  initialState: initialState,
  reducers: {
    openBankDialog: (state, action) => {
      state.isOpenBankDialog = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(bankList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(bankList.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.datas = [...action.payload?.data?.data?.banks];
          state.pagination = action.payload?.data?.data?.pagination;
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(bankList.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      })
      .addCase(bankAdd.pending, (state, action) => {
        state.submitLoading = true;
      })
      .addCase(bankAdd.fulfilled, (state, action) => {
        state.status = '';
        if (action.payload?.status === 200) {
            console.log(action.payload)
          state.datas.unshift(action.payload?.data?.data?.bank);
          state.info = action.payload?.data.message;
          state.status = 'achieve';
          toast.success(action.payload?.data.message);
        } else {

          toast.error(action.payload?.data.message);
        }
        state.formError = action.payload?.data.errors;
        state.submitLoading = false;
      })
      .addCase(bankAdd.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
      })
      .addCase(bankEdit.pending, (state, action) => {
        state.info = '';
        state.submitLoading = true;
      })
      .addCase(bankEdit.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.info = action.payload?.data.message;
          const index = state.datas.findIndex(
            (client) => client.id === action.payload.data?.data?.bank?.id,
          );
          state.datas[index] = {
            ...state[index],
            ...action.payload.data?.data?.bank,
          };
          toast.success(action.payload?.data.message);
        } else {
          toast.error(action.payload?.data.message);
        }
        state.formError = action.payload?.data.errors;
        state.submitLoading = false;
      })
      .addCase(bankEdit.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
      })
      .addCase(bankDelt.pending, (state, action) => {
        state.info = '';
        state.submitLoading = true;
      })
      .addCase(bankDelt.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          let index = state.datas.findIndex(({ id }) => id === action.payload.data?.data?.bank?.id);
          state.datas.splice(index, 1);
          state.info = action.payload?.data.message;
          toast.success(action.payload?.data.message);
        }
        state.submitLoading = false;
      })
      .addCase(bankDelt.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
      })
      .addCase(bankAll.pending, (state, action) => {
        state.loading = true
      })
      .addCase(bankAll.fulfilled, (state, action) => {
        if(action.payload?.status === 200) {
            state.bankoptions = action.payload?.data?.data;
        } else {
            state.error = action.payload?.data.message;
            toast.error(state.error);
        }
        state.loading = false;
        })
        .addCase(bankAll.rejected, (state, action) => {
            state.error = action.payload?.data?.message;
            state.loading = false;
            toast.error(state.error);
        });
  },
});

const { reducer } = bankAction;

export const { openBankDialog } = bankAction.actions;

export const bankSelector = (state) => state?.bank;

export default reducer;
